import { PAGE_LIST_TYPES } from 'tradera-apps/my-tradera/app/constants/list-types';

/**
 * @returns {object} list of default cookies that could be set in Touchweb
 * @desc
 * key: Cookie Name
 * default: Default Value if not set
 * length: Time to be stored (months)
 */
export const DEFAULT_COOKIES = {
    ITEM_LAYOUT: {
        key: 'Srp_Item_Layout',
        default: 'layout-grid',
        length: 365
    },
    SITE_LAYOUT: {
        key: 'Srp_Site_Layout',
        default: 'site-width-default',
        length: 365
    }
};

export const MYTRADERA_DEFAULT_COOKIES = {
    LIST_VIEW_TYPE: {
        key: 'MyTradera_ListViewType',
        default: 'Basic',
        length: 365
    },
    ITEMS_PER_PAGE: {
        key: 'MyTradera_ItemsPerPage',
        default: '25',
        length: 365
    },
    SHOW_FILTERS: {
        key: 'MyTradera_ShowFiltersToolbar',
        default: 'hidden',
        length: 365
    },
    LIST_VIEW_TYPE_BUYER_ACTIVE_ITEMS: {
        key: 'MyTradera_ListViewType_' + PAGE_LIST_TYPES.BUYER_ACTIVE_ITEMS,
        default: null,
        length: 365
    },
    LIST_VIEW_TYPE_BUYER_PURCHASES: {
        key: 'MyTradera_ListViewType_' + PAGE_LIST_TYPES.BUYER_PURCHASES,
        default: null,
        length: 365
    },
    LIST_VIEW_TYPE_BUYER_ITEMS_LOST: {
        key: 'MyTradera_ListViewType_' + PAGE_LIST_TYPES.BUYER_ITEMS_LOST,
        default: null,
        length: 365
    },
    LIST_VIEW_TYPE_SELLER_ACTIVE: {
        key: 'MyTradera_ListViewType_' + PAGE_LIST_TYPES.SELLER_ACTIVE,
        default: null,
        length: 365
    },
    LIST_VIEW_TYPE_SELLER_SOLD: {
        key: 'MyTradera_ListViewType_' + PAGE_LIST_TYPES.SELLER_SOLD,
        default: null,
        length: 365
    },
    LIST_VIEW_TYPE_SELLER_NOT_SOLD: {
        key: 'MyTradera_ListViewType_' + PAGE_LIST_TYPES.SELLER_NOT_SOLD,
        default: null,
        length: 365
    }
};

export const CURRENCY_SELECTED_BY_USER = 'currency_selected_by_user';
export const GDPR_CONSENT_ALERT_DISMISSED = 'gdpr_dismissed_v1';
export const GDPR_CONSENT_COOKIE = 'gdpr_consent_v1';
export const FORCE_GEO_DEV = 'force-geo-dev';
export const ITEMS_PER_PAGE = 'ITEMS_PER_PAGE';
export const LIST_VIEW_TYPE = 'LIST_VIEW_TYPE';
export const MOBILE_OPT_IN_TAGS = 'mobile-opt-in-tags';
export const NATIVE_APP_ENVIRONMENT = 'native-app-environment';
export const PREFERRED_CURRENCY = 'preferred_currency';
export const REGION_PICKER_DISMISSED = 'region_picker_dismissed_session';
export const S = 's';
export const SHIPPING_COUNTRY = 'shipping_country';
export const SHOW_FILTERS = 'SHOW_FILTERS';
export const SIGNUP_REFERRAL_PATH = 'signup_referral_path';
export const SOLD_VIEW_PICKLIST = 'sold_view_picklist';
export const TEST = 'test';
export const USERPREFERENCES = 'UserPreferences';
export const CART_ID = 'cartId';
export const VIEWPORT_WIDTH = 'viewport-width';
export const SHIP_TO_SWEDEN_DISCLAIMER_DISMISSED =
    'ship-to-sweden-disclaimer-dismissed';
export const EXPERIMENTS = 'experiments';

export const COOKIE_CATEGORIES = {
    Essential: 1,
    Performance: 2,
    Functional: 3,
    Marketing: 4
};

/**
 * all cookies that are used by tradera must be categorized in the array below.
 */
export const CATEGORIZED_COOKIES = {
    [GDPR_CONSENT_ALERT_DISMISSED]: COOKIE_CATEGORIES.Essential,
    [GDPR_CONSENT_COOKIE]: COOKIE_CATEGORIES.Essential,
    [NATIVE_APP_ENVIRONMENT]: COOKIE_CATEGORIES.Essential,
    [TEST]: COOKIE_CATEGORIES.Essential, // Unit test cookie

    [CURRENCY_SELECTED_BY_USER]: COOKIE_CATEGORIES.Functional,
    [DEFAULT_COOKIES.ITEM_LAYOUT.key]: COOKIE_CATEGORIES.Functional,
    [DEFAULT_COOKIES.SITE_LAYOUT.key]: COOKIE_CATEGORIES.Functional,
    [EXPERIMENTS]: COOKIE_CATEGORIES.Functional,
    [FORCE_GEO_DEV]: COOKIE_CATEGORIES.Functional,
    [ITEMS_PER_PAGE]: COOKIE_CATEGORIES.Functional,
    [LIST_VIEW_TYPE]: COOKIE_CATEGORIES.Functional,
    [MOBILE_OPT_IN_TAGS]: COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.ITEMS_PER_PAGE.key]:
        COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.LIST_VIEW_TYPE.key]:
        COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.SHOW_FILTERS.key]: COOKIE_CATEGORIES.Functional,
    [PREFERRED_CURRENCY]: COOKIE_CATEGORIES.Functional,
    [REGION_PICKER_DISMISSED]: COOKIE_CATEGORIES.Functional,
    [S]: COOKIE_CATEGORIES.Functional, // saved search
    [SHIPPING_COUNTRY]: COOKIE_CATEGORIES.Functional,
    [SHOW_FILTERS]: COOKIE_CATEGORIES.Functional,
    [SIGNUP_REFERRAL_PATH]: COOKIE_CATEGORIES.Functional,
    [SOLD_VIEW_PICKLIST]: COOKIE_CATEGORIES.Functional,
    [USERPREFERENCES]: COOKIE_CATEGORIES.Functional,
    [CART_ID]: COOKIE_CATEGORIES.Functional,
    [VIEWPORT_WIDTH]: COOKIE_CATEGORIES.Functional,
    [SHIP_TO_SWEDEN_DISCLAIMER_DISMISSED]: COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.LIST_VIEW_TYPE_BUYER_ACTIVE_ITEMS.key]:
        COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.LIST_VIEW_TYPE_BUYER_ITEMS_LOST.key]:
        COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.LIST_VIEW_TYPE_BUYER_PURCHASES.key]:
        COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.LIST_VIEW_TYPE_SELLER_ACTIVE.key]:
        COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.LIST_VIEW_TYPE_SELLER_NOT_SOLD.key]:
        COOKIE_CATEGORIES.Functional,
    [MYTRADERA_DEFAULT_COOKIES.LIST_VIEW_TYPE_SELLER_SOLD.key]:
        COOKIE_CATEGORIES.Functional
};

export const COOKIE_DEFAULT_CATEGORY = COOKIE_CATEGORIES.Functional;

/**
 * List of cookies which are OK for any JavaScript to access. Never add cookies
 * that would be a security risk if exposed to third party scripts.
 */
export const COOKIES_REQUIRED_FOR_SSR_EXPOSED_TO_JS_IN_BROWSER = [
    EXPERIMENTS,
    GDPR_CONSENT_COOKIE,
    REGION_PICKER_DISMISSED,
    SHIPPING_COUNTRY
];
